<script setup lang="ts">
  defineProps<{
    disabled?: boolean,
  }>()
</script>

<template>
  <div class="ellipsis-menu">
    <app-dropdown
      :right="true"
      :disabled="disabled">
      <div class="size-6">
        <fa-icon icon="i-far-ellipsis-vertical" />
      </div>

      <template #items>
        <slot></slot>
      </template>
    </app-dropdown>
  </div>
</template>

<style lang="postcss">
  .card-content .ellipsis-menu {
    @apply absolute top-4 right-2;
  }
</style>
